import React from 'react';
import {Layout, Typography, Button} from 'antd';
import {useNavigate} from 'react-router-dom';
import Header from "../../../components/molecules/Header/component";
import {useIsMobile} from '../../../utils/helpers';
import Footer from "../../../components/molecules/Footer/component";

const {Content} = Layout;
const {Title, Paragraph} = Typography;

const CareersPage: React.FC = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    return (
        <Layout style={{minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "white"}}>
            <Header/>
            <Content style={{flex: 1, maxWidth: 900, margin: '0 auto', padding: '32px 16px 48px'}}>
                <article>
                    <header>
                        <Title level={2}>Careers</Title>
                        <Paragraph>
                            We’re not hiring for any open positions at the moment.
                        </Paragraph>
                        <Paragraph>
                            However, we’re always happy to connect with talented people who are interested
                            in marketing technology, growth platforms, and building useful tools for businesses.
                        </Paragraph>
                        <Paragraph>
                            If you’d like to introduce yourself, feel free to email us at{' '}
                            <a href="mailto:info@promotifyai.com">info@promotifyai.com</a>.
                        </Paragraph>
                    </header>

                    <footer
                        style={{
                            marginTop: 24,
                            display: 'flex',
                            gap: 8,
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: isMobile ? 'stretch' : 'flex-end'
                        }}
                    >
                        <Button
                            type="default"
                            onClick={() => navigate('/contact')}
                            block={isMobile}
                            style={{width: isMobile ? '100%' : 'auto'}}
                        >
                            Contact support
                        </Button>
                    </footer>
                </article>
            </Content>
            <Footer/>
        </Layout>
    );
};

export default CareersPage;